import { useEffect, useState } from "react";
import {
  loadAudioPreference,
  setMusicEnabled,
  setSfxEnabled,
  isMusicEnabled,
  isSfxEnabled,
  sfx,
} from "@/game/audioEngine";

export default function SoundToggle() {
  const [music, setMusic] = useState(false);
  const [sfxOn, setSfxOn] = useState(false);

  useEffect(() => {
    const p = loadAudioPreference();
    setMusic(p.music);
    setSfxOn(p.sfx);
  }, []);

  const toggleMusic = () => {
    const next = !isMusicEnabled();
    setMusicEnabled(next);
    setMusic(next);
    if (next) sfx.ding();
  };

  const toggleSfx = () => {
    const next = !isSfxEnabled();
    setSfxEnabled(next);
    setSfxOn(next);
    if (next) sfx.ding();
  };

  return (
    <div className="fixed right-3 z-40 flex flex-col gap-1.5 items-end bottom-3 md:top-3 md:bottom-auto">
      <button
        type="button"
        onClick={toggleMusic}
        data-testid="music-toggle"
        aria-pressed={music}
        aria-label={music ? "Music on" : "Music off"}
        className="pixel-font text-[9px] bg-[#141414] text-white border-4 border-black px-2.5 py-1.5 shadow-[3px_3px_0_0_#000] hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-[2px_2px_0_0_#000] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-all flex items-center gap-1.5 min-w-[120px] justify-between"
      >
        <span>{music ? "♫" : "♪"}</span>
        <span>MUSIC {music ? "ON" : "OFF"}</span>
      </button>
      <button
        type="button"
        onClick={toggleSfx}
        data-testid="sfx-toggle"
        aria-pressed={sfxOn}
        aria-label={sfxOn ? "Sound effects on" : "Sound effects off"}
        className="pixel-font text-[9px] bg-[#141414] text-white border-4 border-black px-2.5 py-1.5 shadow-[3px_3px_0_0_#000] hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-[2px_2px_0_0_#000] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-all flex items-center gap-1.5 min-w-[120px] justify-between"
      >
        <span>{sfxOn ? "🔊" : "🔈"}</span>
        <span>SFX {sfxOn ? "ON" : "OFF"}</span>
      </button>
    </div>
  );
}
